import React, {lazy, Suspense, useEffect, useState} from 'react';
import styles from './HelpSectionBody.module.scss';
import HelpSectionAnimation from './HelpSectionAnimation';
import {Col, Row} from 'reactstrap';
import cx from 'classnames';
import SectionAccordion from '../SectionAccordion';
import {SERVICES} from '.';
import HelpSectionVideo from './HelpSectionVideo';

const HelpSectionImage = lazy(() => import('./HelpSectionImage'));

function HelpSectionBody({items, tab}) {
  const [selected, setSelected] = useState(items[0]);
  const toggle = (value) => setSelected(value);

  useEffect(() => {
    setSelected(items[0]);
  }, [items]);

  const {animation, image, video, title, videoProps} = selected || {};

  return (
    <div className={styles['body']}>
      <Row>
        <Col className={cx(styles['body--accordion'], 'col-12 col-lg-5')}>
          <SectionAccordion
            light
            items={items}
            selected={selected}
            toggle={toggle}
            accent={{main: SERVICES[tab].color}}
          />
        </Col>
        <Col className={cx(styles['body--animations'], 'col-12 col-lg-7')}>
          {!!animation && (
            <HelpSectionAnimation url={animation} key={animation} />
          )}
          {!!image && (
            <Suspense fallback={null}>
              <HelpSectionImage url={image} alt={title} />
            </Suspense>
          )}
          {!!video && (
            <HelpSectionVideo
              key={video}
              title={title}
              src={video}
              {...videoProps}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default HelpSectionBody;
